import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { Toaster } from 'sonner';

export function App() {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster
        theme="dark"
        position="bottom-right"
        richColors
        closeButton
        toastOptions={{
          style: {
            background: 'var(--color-bg-elevated)',
            border: '1px solid rgba(255,255,255,0.08)',
            color: 'var(--color-primary)',
          },
        }}
      />
    </>
  );
}
